// extracted by mini-css-extract-plugin
export var banner = "_20-0";
export var icon = "_20-1";
export var message = "_20-2";